import React from "react";

import template from "./author_profile.rt";

export default class AuthorProfile extends React.Component {
  render() {
    return template.call(this);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/commenting_widget/author_profile.js